module.exports = __webpack_public_path__ + "img/ic_file.774d4a4a.svg";